const Search = {


	visClass: 'masthead__search-term--visible',

	elements: {},

	bind()
	{
		this.elements.searchButton.addEventListener('click', (e) => {
			this.search(e);
		});
	},

	cacheDom()
	{
		this.elements.searchField = document.querySelector('.js-searchField');
		this.elements.searchButton = document.querySelector('.js-searchButton');
	},

	closeOnDocumentClick (e)
	{
		if( !e.target.closest('.masthead__search') )
		{
			this.hide();
		}
	},

	show(e)
	{
		this.elements.searchField.classList.add(this.visClass);
		this.elements.searchField.focus();
		document.addEventListener('click', (e) => {this.closeOnDocumentClick(e)} );
	},

	hide(e)
	{
		this.elements.searchField.classList.remove(this.visClass);
		document.removeEventListener('click', (e) => {this.closeOnDocumentClick(e)} );
	},

	search(e)
	{

		const isVislble = this.elements.searchField.classList.contains(this.visClass);
		const searchTerm = this.elements.searchField.value;

		// panel is open
		if( isVislble )
		{
			// searched for nothing so just close it
			if( searchTerm === '')
			{
				e.preventDefault();
				this.hide(e);
			}
		}

		// panel was closed so show it
		else
		{
			e.preventDefault();
			this.show(e);
		}
	},

	init()
	{
		this.cacheDom();
		this.bind();
	}
};

export default Search;